import styled from 'styled-components';
import { Switch } from '@blueprintjs/core';
export const AppMetierSwitch = styled(Switch) `
  input:checked ~ .bp3-control-indicator {
    background: var(--main-green-1) !important;
  }
`;
//# sourceMappingURL=Switch.js.map